import { RootState } from '../rootReducer';

export const selectUpgradingToProState = (state: RootState): boolean => state.upgradeAccount.data.upgradingToPro;
export const selectConfirmingPaymentProState = (state: RootState): boolean => state.upgradeAccount.data.confirmingProPayment;
export const selectIssuingProUpgradeState = (state: RootState): boolean => state.upgradeAccount.data.issuingProUpgrade;
export const selectUpgradeAccountError = (state: RootState): string | null => state.upgradeAccount.data.error;
export const selectUpgradeToProClientSecret = (state: RootState): string | null => state.upgradeAccount.data.upgradeToProClientSecret;
